export enum PickupTimeCotationEnum {
  MORNING = "MORNING",
  AFTERNOON = "AFTERNOON",
}
